var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    width: "1em",
    height: "1em",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme",
    transform: "translate(-25.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "currentcolor",
    d: "M1025,466.7v116.7H583.3V1025H466.7V583.3H25V466.7h441.7V25h116.7v441.7H1025z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusXs);
export default __webpack_public_path__ + "static/media/plus-xs.78f155cc0ea2dc48e55b50e1eedf01c0.svg";
export { ForwardRef as ReactComponent };